import SEO from '../components/seo';
import Wrapper from '../layout/wrapper';
import AssinarAgoraMain from '../components/assinar-agora';
import { useParams, useNavigate } from 'react-router-dom';

const AssinarAgora = () => {

const { cdPlano } = useParams();

  return (
    <Wrapper>
      <SEO pageTitle={'Assinar Agora'} />
      <AssinarAgoraMain cdPlano={cdPlano} />
    </Wrapper>
  );
};

export default AssinarAgora;